// Utility functions for handling lead data types
// API returns value as string, but we need numbers for calculations

export const parseLeadValue = (value: number | string | null | undefined): number => {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

export const parseLeadProbability = (probability: number | string | null | undefined): number => {
  if (probability === null || probability === undefined) return 0;
  if (typeof probability === 'number') return probability;
  if (typeof probability === 'string') {
    const parsed = parseInt(probability, 10);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

export const formatLeadValue = (value: number | string | null | undefined): string => {
  const numValue = parseLeadValue(value);
  return numValue.toLocaleString();
};

